export enum DeclarationStatus {
  unverified = 'unverified',
  verified = 'verified',
  failed = 'failed',
}
